import React, { useState } from 'react';
import { HiOutlineEye, HiOutlineEyeSlash } from 'react-icons/hi2';

const ReauthField = ({
  id,
  label,
  labelAside,
  value,
  onChange,
  icon: LeadingIcon,
  isPassword = false,
  autoComplete,
  autoFocus = false,
  maxLength
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const inputType = isPassword && !isVisible ? 'password' : 'text';
  const ToggleIcon = isVisible ? HiOutlineEyeSlash : HiOutlineEye;

  const handleToggle = () => setIsVisible((visible) => !visible);

  return (
    <div className="reauth-field">
      <div className="reauth-label-row">
        <label className="reauth-label" htmlFor={id}>
          {label}
        </label>
        {labelAside}
      </div>
      <div className="reauth-input-wrap">
        {LeadingIcon && <LeadingIcon className="reauth-input-icon" aria-hidden="true" />}
        <input
          id={id}
          name={id}
          type={inputType}
          className="form-control tempEdge-input-box"
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          maxLength={maxLength}
          data-testid={id}
        />
        {isPassword && (
          <button type="button" className="reauth-toggle" onClick={handleToggle} data-testid={`${id}-toggle`}>
            <ToggleIcon aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ReauthField;
